import {
  SET_LOADS
} from "./actionTypes";

const initialState = {
  error: "",
  loads: [
    { id: 1, number: 45986, status_id: 18 },
    { id: 2, number: 25699, status_id: 30 }
  ]
};

const loads = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADS:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};

export default loads;
